<i18n src="@/locales/modules/UserSettingsTranslate.json"></i18n>

<template>
	<vx-card no-shadow class="user-general">
		<!-- Img Row -->
		<div class="flex flex-wrap items-center mb-base">
			<input type="file" class="hidden" ref="profilePicture" @change="updateFileAttach($event)" accept="image/*" />

			<vs-avatar :src="avatar" size="70px" class="mr-4 mb-4" />
			<div>
				<vs-button class="mr-4 sm:mb-0 mb-2 font-bold" @click="$refs.profilePicture.click()">{{ $t("UploadPhoto") }}</vs-button>
				<p class="text-sm mt-2">{{ $t("AcceptFileTypes") }}</p>
			</div>
		</div>

		<!-- Info -->
		<vs-input class="w-full mb-base" :label-placeholder="`${$t('Name')}:`" v-model="name"></vs-input>
		<vs-input class="w-full" disabled :label-placeholder="`${$t('Email')}:`" v-model="email"></vs-input>

		<!-- Save & Reset Button -->
		<div class="flex flex-wrap items-center sm:justify-end">
			<vs-button class="w-full sm:w-1/3 sm:max-w-xs mt-4 font-bold" @click="updateProfile">{{ $t("Actions.SaveChanges") }}</vs-button>
		</div>
	</vx-card>
</template>

<script>
export default {
	data() {
		return {
			username: "johny_01",
			name: this.$store.state.AppActiveUser.role.name,
			email: this.$store.state.AppActiveUser.login,
			avatar: this.$store.state.AppActiveUser.role.avatar
		};
	},
	methods: {
		updateFileAttach(input) {
			if (input.target.files && input.target.files[0]) {
				var reader = new FileReader();
				reader.onload = e => {
					this.dataImg = input.target.files[0];
					this.avatar = e.target.result;
					this.$forceUpdate();
				};
				reader.readAsDataURL(input.target.files[0]);
			}
		},

		updateProfile() {
			const payload = {
				name: this.name,
				avatar: this.dataImg
			};
			this.$store.dispatch("auth/updateProfile", payload).then(res => {
				if (res.role) {
					this.$helper.notifySuccess({
						context: this,
						options: {
							title: this.$t("UpdateProfile"),
							text: this.$t("UpdateProfileSuccessful")
						}
					});
				} else {
					this.$helper.notifyError({
						context: this,
						options: {
							title: this.$t("UpdateProfile"),
							text: this.$t("UpdateProfileFailed")
						}
					});
				}
			});
		}
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		}
	}
};
</script>

<style lang="scss" scoped>
.user-general {
	::v-deep .vs-input {
		&.isFocus input,
		input.hasValue {
			& ~ .input-span-placeholder {
				transform: translate(-3px, -65%) !important;
			}
		}
	}
}
</style>
